<template>
  <v-layout class="d-block booking-form-container">
    <loader
      v-if="(!accountSelected || !isBootstrapped)"
      :is-loading="isBootstrapped"
    />

    <booking-steps-form-container
      v-else
      :booking-form-model="bookingFormModel"
      class="booking-form-container-border"
    >
      <template v-slot:title>
        <span class="booking-form-title">{{ $t(`components.bookingForm.title.trip`) }}</span>
      </template>
    </booking-steps-form-container>

  </v-layout>
</template>

<script>

import { mapGetters } from 'vuex';
import BookingStepsFormContainer from '@/views/bookingForm/steps/BookingStepsFormContainer';
import { BookingFormModelFactory } from '@/views/bookingForm/BookingFormModelFactory';
import {BusinessBookerEvent} from "@/core/tracking/businessBookerEvent/BusinessBookerEvent";
import {BusinessBookerEventCode} from "@/core/tracking/businessBookerEvent/BusinessBookerEventCode";

export default {
  name: 'BookingFormContainer',
  components: {
    BookingStepsFormContainer,
  },
  data() {
    return {
      isBootstrapped: false,
      bookingFormModel: null,
    };
  },
  computed: {
    ...mapGetters({
      bookingChannelId: 'bookingChannel/id',
      accountSelected: 'accountsApiStore/accountSelected',
    }),
  },
  async mounted() {
    console.log('We are mounted in Booking Form Container');
    await BusinessBookerEvent.send({
      code: BusinessBookerEventCode.PAGE_VISITED,
      pageUri: window.location.pathname,
    });

    this.bookingFormModel = BookingFormModelFactory.makeForBookingCreation({
      bookingChannelId: this.bookingChannelId,
      paymentProviderName: this.$store.getters['bookingChannel/payment'].name,
      businessAccountId: this.accountSelected,
      tip: {
        base: 'percentage',
        value: 0,
      },
    });

    this.isBootstrapped = true;
  },
};
</script>

<style lang="scss">
.booking-form-container {
  position: relative;

  .v-card {
    height: 100%;
  }
}

.booking-form-container {
  .v-text-field--outlined fieldset {
    background-color: #F8F8F8 !important;
    border-color: #EEEEEE !important;
  }

  .multiple-address-container .address-select .multiselect__tags {
    background-color: #F8F8F8 !important;
    border: 1px solid #EEEEEE !important;
  }
}
</style>

<style lang="scss" scoped>
.booking-form-title {
  font-family: "Inter", sans-serif;
  font-size: 24px;
  font-weight: 600;
  line-height: 34px;
  letter-spacing: -0.005em;
  text-align: left;
}

.booking-form-container-border {
  border-radius: 8px;
  box-shadow: none;
}
</style>
